import { ResponseUpdate } from '../models/common';

export const validateResponseUpdate = (dto: any): ResponseUpdate => {
    return {
        success: 'success' in dto ? dto.success : false,
        error: 'error' in dto ? dto.error : false
    };
};
